import DatePicker from "react-datepicker";
import {LiaDownloadSolid} from "react-icons/lia";
import React, {forwardRef, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {LuCalendarDays, LuCalendarRange} from "react-icons/lu";
import moment from "moment/moment";
import {SlArrowDown} from "react-icons/sl";
import {RiLoader4Fill} from "react-icons/ri";
import {FaChartLine} from "react-icons/fa";

const TimeSeriesSection = ({
                               selectedFreq,
                               startDate,
                               setStartDate,
                               endDate,
                               setEndDate,
                               activeMainReportId,
                               activeReportId,
                               selectedIndicator,
                               currentLang,
                               minDateReport,
                               maxDateReport,
                               downloadReport,
                               handleOptionChange,
                               cycleId = 3,
                               downloadFetchError,
                               isCheck,
                               handleCheckboxChange,
                               showChartButton = false,
                               onOpenChart
                           }) => {

    const {t} = useTranslation();

    const [cycleIds, setCycleIds] = useState([]);
    const [selectedFreqName, setSelectedFreqName] = useState(t('finance.chooseFreq'));
    const [selectedFreqId, setSelectedFreqId] = useState(-1);

    const expandDropDown = (event) => {
        if (minDateReport) {
            const dropdown = event.currentTarget.parentElement;
            dropdown.classList.toggle('freq-dropdown-opened');
        }
    }
    const changeFreq = (value, name) => {
        setSelectedFreqName(name)
        setSelectedFreqId(value)
        handleOptionChange(value)
        const element = document.querySelector('.freq-dropdown-opened');
        if (element) {
            element.classList.remove('freq-dropdown-opened');
        }
    }

    useEffect(() => {
        const cycle = []
        if (cycleId === 1) {
            cycle.push("1")
            cycle.push("3")
            cycle.push("4")
            cycle.push("6")
        } else if (cycleId === 3) {
            cycle.push("3")
            cycle.push("4")
            cycle.push("6")
        } else if (cycleId === 4) {
            cycle.push("4")
            cycle.push("6")
        } else if (cycleId === 6) {
            cycle.push("6")
        }
        setCycleIds(cycle)
    }, [cycleId])

    const CustomInput = forwardRef(({value, onClick}, ref) => (
        <div className={"flex flex-row justify-between example-custom-input cursor-pointer py-1"} onClick={onClick}
             ref={ref}>
            <LuCalendarDays size={"1.2em"} strokeWidth={1}
                            className={"my-auto mx-4" + (value ? " text-black " : " text-stone-600 ")}/>
            <div
                className={"my-auto " + (value ? " text-black " : " text-stone-400 ")}>
                {value ? value : (selectedFreq === '3' ? moment().format("YYYY/MM")
                    : (selectedFreq === '4' ? moment().format("YYYY.Q")
                        : (selectedFreq === '6' ? moment().format("YYYY") : moment().format("YYYY/MM/DD"))))}
            </div>
            <SlArrowDown className={"my-auto mx-4 text-stone-500"} size={"0.8em"} strokeWidth={4}/>
        </div>
    ));

    return (
        <>
            <div className={"flex flex-col ps-3 pt-3 pb-6"}>
                <div className={"text-md font-normal text-gray-600"}>
                    <p>{t('finance.reportList.freq')}</p>
                </div>
                <div className={"grid grid-cols-3 py-2"}>
                    <div className={"freq-drop-down col-span-3 relative inline-block"}>
                        <div
                            className={"freq-drop-down-select flex flex-row rounded-lg border border-stone-300 justify-between cursor-pointer py-1"}
                            onClick={(event) => expandDropDown(event)}>
                            <LuCalendarRange size={"1.2em"} strokeWidth={1}
                                             className={"my-auto mx-4 " + (selectedFreqId !== -1 ? " text-black " : " text-stone-600 ")}/>
                            <div
                                className={"my-auto select-none " + (selectedFreqId !== -1 ? " text-black " : " text-stone-400 ")}>
                                {selectedFreqName}
                            </div>
                            <SlArrowDown className={"my-auto mx-4 text-stone-500"} size={"0.8em"} strokeWidth={4}/>
                        </div>
                        <div
                            className={"freq-drop-down-content absolute bg-white border border-stone-300 rounded-lg w-full z-10"}>
                            {
                                cycleIds.map((e, i) =>
                                    <div key={i}
                                         className={"flex justify-center items-center p-2 cursor-pointer hover:bg-stone-100"}
                                         onClick={() => changeFreq(e, t('finance.freq.f' + e))}>
                                        {t('finance.freq.f' + e)}
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className={"text-md font-normal text-gray-600"}>
                    <p>{t('finance.reportList.startDate')}</p>
                </div>
                <div className={"grid col-span-3 md:col-span-2 py-2"}>
                    <div className={"col-span-2"}>
                        <DatePicker
                            readOnly={!minDateReport}
                            locale={currentLang}
                            showMonthYearPicker={selectedFreq === '3'}
                            showQuarterYearPicker={selectedFreq === '4'}
                            showYearPicker={selectedFreq === '6'}
                            selected={startDate}
                            dateFormat={"yyyy" + (selectedFreq === '3' ?
                                '/MM' : '') + (selectedFreq === '4' ?
                                '.QQQ' : (selectedFreq === '1' ?
                                    '/MM/dd' : ''))}
                            minDate={moment(minDateReport).toDate()}
                            maxDate={endDate ? endDate : moment(maxDateReport).toDate()}
                            onChange={(date) => setStartDate(date)}
                            customInput={<CustomInput/>}/>
                    </div>
                </div>
                <div className={"text-md font-normal text-gray-600"}>
                    <p>{t('finance.reportList.endDate')}</p>
                </div>
                <div className={"grid col-span-3 md:col-span-2 py-2"}>
                    <div className={"col-span-2"}>
                        <DatePicker
                            readOnly={!startDate}
                            locale={currentLang}
                            showMonthYearPicker={selectedFreq === '3'}
                            showQuarterYearPicker={selectedFreq === '4'}
                            showYearPicker={selectedFreq === '6'}
                            selected={endDate}
                            dateFormat={"yyyy" + (selectedFreq === '3' ?
                                '/MM' : '') + (selectedFreq === '4' ?
                                '.QQQ' : (selectedFreq === '1' ?
                                    '/MM/dd' : ''))}
                            minDate={startDate}
                            maxDate={moment(maxDateReport).toDate()}
                            onChange={(date) => setEndDate(date)}
                            customInput={<CustomInput/>}/>
                    </div>
                </div>
                <div className={"grid col-span-3 md:col-span-2 py-2"}>
                    <div className={"col-span-2 flex flex-row gap-2"}>
                        <input type="checkbox"
                               checked={isCheck}
                               onChange={handleCheckboxChange}
                               className={"w-5 accent-[#163578] hover:accent-[#163578] cursor-pointer"}/>
                        <p className={"text-md font-normal text-gray-600"}>{t('finance.reportList.checkboxRoundedDecimal')}</p>
                    </div>
                </div>
                {showChartButton ?
                    <div className={"grid grid-cols-3 w-fit"}>
                        <button
                            type="button"
                            className="col-span-3 mt-4 px-4 py-2 bg-yellow-500 text-[#163578] rounded-md justify-start items-center gap-2 inline-flex cursor-pointer"
                            onClick={onOpenChart}>
                            <FaChartLine/>
                            <span className="text-sm font-bold select-none">
                                {t('finance.chart.viewButton')}
                            </span>
                        </button>
                    </div> : ""}
                {startDate && endDate && selectedFreq && activeMainReportId && activeReportId && selectedIndicator.length > 0 ?
                    <div className={"grid grid-cols-3 w-fit "}>
                        <div
                            className="col-span-3 mt-4 px-4 py-2 bg-yellow-500 text-[#163578] rounded-md justify-start items-center gap-2 inline-flex cursor-pointer"
                            onClick={() => downloadReport()}>
                            {downloadFetchError === -1 ? <RiLoader4Fill className={"animate-spin"}/> :
                                <LiaDownloadSolid/>}
                            <div className=" text-sm  font-bold select-none">
                                {downloadFetchError === -1 ? t('finance.reportList.downloadButtonLoading')
                                    : t('finance.reportList.downloadButton')}
                            </div>
                        </div>
                    </div> : ""}
            </div>
        </>
    )

}

export default TimeSeriesSection;
